import React, { FC } from 'react'
import { Button } from '@resurs/midas-react'
import { getText } from '../../../app/internal/TextLabels'
import AppIcon from '../../../app/internal/AppIcon'
import styles from './ModuleVersionNotification.module.scss'

const ModuleVersionNotification: FC<{
  moduleName: string
  hide: () => void
}> = ({ moduleName, hide }) => (
  <div className={styles.ModuleVersionNotification}>
    <div className={styles.header}>
      <h6>{getText('default.reloadPage')}</h6>
      <AppIcon close onClick={hide} />
    </div>
    <div className={styles.body}>
      {getText('modules.newVersion', {
        moduleName,
      })}
    </div>
    <hr className={styles.hr} />
    <div className={styles.footer}>
      <Button
        type="link"
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          window.location.reload()
        }}
      >
        {getText('default.reloadPage')}
      </Button>
    </div>
  </div>
)
export default ModuleVersionNotification
